import React from 'react';
import classNames from 'classnames';

const Icon = ({ title, name, className, children, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('icon', className)}
    aria-hidden
    {...props}
  >
    {title && <title>{title}</title>}
    {name && (
      <use
        xlinkHref={`${window.kvs.theme_link}/dist/icons/sprite.svg#${name}`}
      />
    )}
    {children}
  </svg>
);

export default Icon;
